// THIS FILE IS AUTO-GENERATED by tools/bca/sync-insurance-companies/sync-insurance-companies.ts
// Do not edit manually — run the sync tool to update.

export enum StarnormInsuranceCompanyId {
  AdamRiese = "40147",
  Adcuri = "40016",
  Aia = "43321",
  Aig = "43310",
  AllianzSach = "40012",
  AllianzLeben = "30012",
  AllianzKv = "44009",
  Allianzagrar = "40149",
  AlteLeipzigerLv = "30030",
  Alteleipziger = "42009",
  AlteOldenburger = "44017",
  Alteos = "40291",
  AmmerlaenderVvag = "40049",
  Andsafe = "40280",
  AngloUnderwriting = "40014",
  AprilDeutschland = "44010",
  AragAllgVersAg = "40050",
  AragKvAg = "44028",
  AxaDbv = "42005",
  AxaDbvLeben = "30017",
  AxaDbvKv = "44005",
  BadenBadener = "40001",
  BaloiseSach = "41017",
  BaloiseLv = "30031",
  BaloiseLvAlt = "30005",
  BarmeniaSach = "41006",
  BarmeniaLv = "30006",
  BarmeniaKv = "44003",
  BbkkUnionKv = "44012",
  Bgv = "40027",
  Bgvkfztool = "40304",
  Blaudirektver = "40300",
  Bsg = "43320",
  CanadaLife = "30046",
  CareConceptAg = "44050",
  CentralKv = "44019",
  CfiFairpay = "31001",
  Compactteam = "40151",
  ConceptifAg = "43200",
  Concordia = "40026",
  ConcordiaLvAg = "30053",
  ConcordiaKvAg = "44029",
  Concordiakfztool = "40305",
  CondorLvAg = "30054",
  Continentale = "40100",
  ContinentaleLv = "30024",
  ContinentaleKv = "44007",
  Covomo = "40145",
  DaDirekt = "40024",
  DbVitaPremium = "30041",
  DbVitaPremiumSel = "30042",
  Dela = "31004",
  Deurag = "43000",
  DfvKv = "44049",
  DialogSach = "40290",
  DialogLeben = "30029",
  DieBayerischeSach = "40005",
  DieBayerischeLv = "30047",
  DieBayerischeKv = "44006",
  DieHaftpflichtkasse = "41007",
  DkvDeutscheKvAg = "44032",
  DmbRsAg = "40068",
  DocuraVvag = "40069",
  Domcura = "41001",
  DomcuraKv = "44020",
  ErgoAg = "40073",
  ErgoLvAg = "30064",
  ErgoDirekt = "30010",
  ErgoLifeSaVLux = "30902",
  Europa = "40030",
  EuropaKv = "44065",
  EuropaLvAg = "30065",
  FidelisUnderwriting = "40015",
  Forbrokergmbh = "41020",
  GerlingGA = "41003",
  GermanbrokerNetAg = "40146",
  GothaerSach = "40023",
  GothaerLeben = "30021",
  GothaerKv = "44021",
  Grundeigentuemer = "40159",
  GvoVvag = "40082",
  Hallesche = "44013",
  HannoverscheLeben = "30044",
  HansemerkurKomposit = "40090",
  HansemerkurLv = "30020",
  HansemerkurKv = "44022",
  HdiPrivatGewerbe = "41004",
  Hdi = "30008",
  HdiGewerbeInaktiv = "41005",
  HdiGlobalSe = "41008",
  Hek = "44026",
  HelvetiaKompositAg = "40092",
  HelvetiaLvAg = "30071",
  Hiscox = "40011",
  HuebenerAg = "40093",
  IdealSach = "40018",
  IdealLeben = "30018",
  InoraLife = "30022",
  Intasure = "43322",
  InterSach = "40200",
  InterLv = "30025",
  InterKv = "44008",
  InterlloydAg = "40096",
  Interrisk = "40006",
  InterriskLeben = "30014",
  Itzehoer = "42007",
  Janitos = "40008",
  JanitosKv = "44024",
  KM = "40022",
  Kravag = "40028",
  KsAuxilia = "43100",
  Landeskrankenhilfe = "44036",
  LibertyEurope = "30002",
  Lta = "43323",
  Lv1871Sach = "41038",
  Lv1871 = "30038",
  MannheimerKomposit = "40104",
  ManufakturAugsburg = "43300",
  MarkelInternational = "40039",
  MuenchenerVereinLv = "30078",
  MuenchenerVereinKv = "44015",
  MylifeLvAg = "30079",
  Neodigital = "40148",
  NeueLeben = "30001",
  NlHdiPensionsman = "30032",
  NrvRechtsschutz = "40009",
  NuernbergerSach = "40013",
  NuernbergerLv = "30036",
  NuernbergerKv = "44018",
  NvVvag = "40111",
  Ostangler = "40150",
  Prokundo = "40034",
  ProvinzialMuenster = "40118",
  RV = "41015",
  RVLvAG = "30088",
  RVKvAg = "44044",
  RechtsschutzUnion = "40019",
  Rhion = "40038",
  RolandRs = "40020",
  Sichergruen = "40330",
  SignalIdunaLeben = "30023",
  SignalIduna = "40128",
  SignalKv = "44002",
  Skandia = "30007",
  Skendata = "41041",
  SlpAg = "40320",
  SparkasseDirekt = "40029",
  StandardLife = "30034",
  StuttgarterSach = "40037",
  StuttgarterLeben = "30037",
  StuttgarterKv = "44037",
  SueddeutscheKv = "44023",
  SwissLifeLv = "30009",
  SwissLifeAt = "30048",
  UelzenerKomposit = "40133",
  UkvInaktiv = "44011",
  UniversaKompositAg = "40135",
  UniversaLvAG = "30096",
  UniversaKv = "44016",
  VkbSach = "40137",
  VertiLv = "30319",
  VertiSach = "40319",
  Vhv = "42002",
  ViennaLife = "30039",
  VolkswohlBundSach = "40033",
  VolkswohlBundLeben = "30033",
  Waldenburger = "40010",
  Wueba = "40002",
  WuerttembergischeAg = "40142",
  WuerttembergischeLv = "30103",
  WuerttembergischeKv = "44048",
  WwkKompositAg = "40144",
  WwkLv = "30019",
  Zurich = "42008",
  ZurichLv = "30043",
  ZurichLifeIrland = "30011",
  Zurichkfztool = "40318",
}

export const STARNORM_INSURANCE_COMPANY_LABELS: Readonly<Record<StarnormInsuranceCompanyId, string>> = {
  [StarnormInsuranceCompanyId.AdamRiese]: "Adam Riese",
  [StarnormInsuranceCompanyId.Adcuri]: "Adcuri",
  [StarnormInsuranceCompanyId.Aia]: "AIA",
  [StarnormInsuranceCompanyId.Aig]: "AIG",
  [StarnormInsuranceCompanyId.AllianzSach]: "Allianz Sach",
  [StarnormInsuranceCompanyId.AllianzLeben]: "Allianz Leben",
  [StarnormInsuranceCompanyId.AllianzKv]: "Allianz KV",
  [StarnormInsuranceCompanyId.Allianzagrar]: "AllianzAgrar",
  [StarnormInsuranceCompanyId.AlteLeipzigerLv]: "Alte Leipziger LV",
  [StarnormInsuranceCompanyId.Alteleipziger]: "AlteLeipziger",
  [StarnormInsuranceCompanyId.AlteOldenburger]: "Alte Oldenburger",
  [StarnormInsuranceCompanyId.Alteos]: "Alteos",
  [StarnormInsuranceCompanyId.AmmerlaenderVvag]: "Ammerländer VVaG",
  [StarnormInsuranceCompanyId.Andsafe]: "andsafe",
  [StarnormInsuranceCompanyId.AngloUnderwriting]: "Anglo Underwriting",
  [StarnormInsuranceCompanyId.AprilDeutschland]: "April Deutschland",
  [StarnormInsuranceCompanyId.AragAllgVersAg]: "ARAG Allg. Vers.- AG",
  [StarnormInsuranceCompanyId.AragKvAg]: "ARAG KV AG",
  [StarnormInsuranceCompanyId.AxaDbv]: "AXA / DBV",
  [StarnormInsuranceCompanyId.AxaDbvLeben]: "AXA/DBV Leben",
  [StarnormInsuranceCompanyId.AxaDbvKv]: "AXA / DBV KV",
  [StarnormInsuranceCompanyId.BadenBadener]: "Baden-Badener",
  [StarnormInsuranceCompanyId.BaloiseSach]: "Baloise Sach",
  [StarnormInsuranceCompanyId.BaloiseLv]: "Baloise LV",
  [StarnormInsuranceCompanyId.BaloiseLvAlt]: "Baloise LV alt",
  [StarnormInsuranceCompanyId.BarmeniaSach]: "Barmenia Sach",
  [StarnormInsuranceCompanyId.BarmeniaLv]: "Barmenia LV",
  [StarnormInsuranceCompanyId.BarmeniaKv]: "Barmenia KV",
  [StarnormInsuranceCompanyId.BbkkUnionKv]: "BBKK / Union KV",
  [StarnormInsuranceCompanyId.Bgv]: "BGV",
  [StarnormInsuranceCompanyId.Bgvkfztool]: "BGVKFZTool",
  [StarnormInsuranceCompanyId.Blaudirektver]: "BlauDirektVer",
  [StarnormInsuranceCompanyId.Bsg]: "BSG",
  [StarnormInsuranceCompanyId.CanadaLife]: "Canada Life",
  [StarnormInsuranceCompanyId.CareConceptAg]: "Care Concept AG",
  [StarnormInsuranceCompanyId.CentralKv]: "Central KV",
  [StarnormInsuranceCompanyId.CfiFairpay]: "CFI FairPay",
  [StarnormInsuranceCompanyId.Compactteam]: "CompactTeam",
  [StarnormInsuranceCompanyId.ConceptifAg]: "ConceptIF AG",
  [StarnormInsuranceCompanyId.Concordia]: "Concordia",
  [StarnormInsuranceCompanyId.ConcordiaLvAg]: "Concordia LV AG",
  [StarnormInsuranceCompanyId.ConcordiaKvAg]: "Concordia KV AG",
  [StarnormInsuranceCompanyId.Concordiakfztool]: "ConcordiaKFZTool",
  [StarnormInsuranceCompanyId.CondorLvAg]: "Condor LV AG",
  [StarnormInsuranceCompanyId.Continentale]: "Continentale",
  [StarnormInsuranceCompanyId.ContinentaleLv]: "Continentale LV",
  [StarnormInsuranceCompanyId.ContinentaleKv]: "Continentale KV",
  [StarnormInsuranceCompanyId.Covomo]: "Covomo",
  [StarnormInsuranceCompanyId.DaDirekt]: "DA Direkt",
  [StarnormInsuranceCompanyId.DbVitaPremium]: "DB Vita Premium",
  [StarnormInsuranceCompanyId.DbVitaPremiumSel]: "DB Vita Premium Sel",
  [StarnormInsuranceCompanyId.Dela]: "DELA",
  [StarnormInsuranceCompanyId.Deurag]: "Deurag",
  [StarnormInsuranceCompanyId.DfvKv]: "DFV KV",
  [StarnormInsuranceCompanyId.DialogSach]: "Dialog Sach",
  [StarnormInsuranceCompanyId.DialogLeben]: "Dialog Leben",
  [StarnormInsuranceCompanyId.DieBayerischeSach]: "Die Bayerische Sach",
  [StarnormInsuranceCompanyId.DieBayerischeLv]: "Die Bayerische LV",
  [StarnormInsuranceCompanyId.DieBayerischeKv]: "Die Bayerische KV",
  [StarnormInsuranceCompanyId.DieHaftpflichtkasse]: "die Haftpflichtkasse",
  [StarnormInsuranceCompanyId.DkvDeutscheKvAg]: "DKV Deutsche KV AG",
  [StarnormInsuranceCompanyId.DmbRsAg]: "DMB RS AG",
  [StarnormInsuranceCompanyId.DocuraVvag]: "DOCURA VVaG",
  [StarnormInsuranceCompanyId.Domcura]: "Domcura",
  [StarnormInsuranceCompanyId.DomcuraKv]: "Domcura KV",
  [StarnormInsuranceCompanyId.ErgoAg]: "ERGO AG",
  [StarnormInsuranceCompanyId.ErgoLvAg]: "ERGO LV AG",
  [StarnormInsuranceCompanyId.ErgoDirekt]: "ERGO Direkt",
  [StarnormInsuranceCompanyId.ErgoLifeSaVLux]: "ERGO Life SA (V.Lux)",
  [StarnormInsuranceCompanyId.Europa]: "Europa",
  [StarnormInsuranceCompanyId.EuropaKv]: "EUROPA KV",
  [StarnormInsuranceCompanyId.EuropaLvAg]: "EUROPA LV AG",
  [StarnormInsuranceCompanyId.FidelisUnderwriting]: "Fidelis Underwriting",
  [StarnormInsuranceCompanyId.Forbrokergmbh]: "forbrokerGmbH",
  [StarnormInsuranceCompanyId.GerlingGA]: "Gerling G&A",
  [StarnormInsuranceCompanyId.GermanbrokerNetAg]: "germanBroker.net AG",
  [StarnormInsuranceCompanyId.GothaerSach]: "Gothaer Sach",
  [StarnormInsuranceCompanyId.GothaerLeben]: "Gothaer Leben",
  [StarnormInsuranceCompanyId.GothaerKv]: "Gothaer KV",
  [StarnormInsuranceCompanyId.Grundeigentuemer]: "Grundeigentümer",
  [StarnormInsuranceCompanyId.GvoVvag]: "GVO VVaG",
  [StarnormInsuranceCompanyId.Hallesche]: "Hallesche",
  [StarnormInsuranceCompanyId.HannoverscheLeben]: "Hannoversche Leben",
  [StarnormInsuranceCompanyId.HansemerkurKomposit]: "HanseMerkur Komposit",
  [StarnormInsuranceCompanyId.HansemerkurLv]: "HanseMerkur LV",
  [StarnormInsuranceCompanyId.HansemerkurKv]: "HanseMerkur KV",
  [StarnormInsuranceCompanyId.HdiPrivatGewerbe]: "HDI Privat/Gewerbe",
  [StarnormInsuranceCompanyId.Hdi]: "HDI",
  [StarnormInsuranceCompanyId.HdiGewerbeInaktiv]: "HDI Gewerbe inaktiv",
  [StarnormInsuranceCompanyId.HdiGlobalSe]: "HDI Global SE",
  [StarnormInsuranceCompanyId.Hek]: "HEK",
  [StarnormInsuranceCompanyId.HelvetiaKompositAg]: "Helvetia Komposit AG",
  [StarnormInsuranceCompanyId.HelvetiaLvAg]: "Helvetia LV AG",
  [StarnormInsuranceCompanyId.Hiscox]: "Hiscox",
  [StarnormInsuranceCompanyId.HuebenerAg]: "Hübener AG",
  [StarnormInsuranceCompanyId.IdealSach]: "Ideal Sach",
  [StarnormInsuranceCompanyId.IdealLeben]: "Ideal Leben",
  [StarnormInsuranceCompanyId.InoraLife]: "inora life",
  [StarnormInsuranceCompanyId.Intasure]: "Intasure",
  [StarnormInsuranceCompanyId.InterSach]: "Inter Sach",
  [StarnormInsuranceCompanyId.InterLv]: "Inter LV",
  [StarnormInsuranceCompanyId.InterKv]: "Inter KV",
  [StarnormInsuranceCompanyId.InterlloydAg]: "Interlloyd AG",
  [StarnormInsuranceCompanyId.Interrisk]: "InterRisk",
  [StarnormInsuranceCompanyId.InterriskLeben]: "InterRisk Leben",
  [StarnormInsuranceCompanyId.Itzehoer]: "Itzehoer",
  [StarnormInsuranceCompanyId.Janitos]: "Janitos",
  [StarnormInsuranceCompanyId.JanitosKv]: "Janitos KV",
  [StarnormInsuranceCompanyId.KM]: "K&M",
  [StarnormInsuranceCompanyId.Kravag]: "Kravag",
  [StarnormInsuranceCompanyId.KsAuxilia]: "KS Auxilia",
  [StarnormInsuranceCompanyId.Landeskrankenhilfe]: "Landeskrankenhilfe",
  [StarnormInsuranceCompanyId.LibertyEurope]: "Liberty Europe",
  [StarnormInsuranceCompanyId.Lta]: "LTA",
  [StarnormInsuranceCompanyId.Lv1871Sach]: "LV 1871 Sach",
  [StarnormInsuranceCompanyId.Lv1871]: "LV 1871",
  [StarnormInsuranceCompanyId.MannheimerKomposit]: "Mannheimer Komposit",
  [StarnormInsuranceCompanyId.ManufakturAugsburg]: "Manufaktur Augsburg",
  [StarnormInsuranceCompanyId.MarkelInternational]: "Markel International",
  [StarnormInsuranceCompanyId.MuenchenerVereinLv]: "Münchener Verein LV",
  [StarnormInsuranceCompanyId.MuenchenerVereinKv]: "Münchener Verein KV",
  [StarnormInsuranceCompanyId.MylifeLvAg]: "myLife LV AG",
  [StarnormInsuranceCompanyId.Neodigital]: "Neodigital",
  [StarnormInsuranceCompanyId.NeueLeben]: "neue leben",
  [StarnormInsuranceCompanyId.NlHdiPensionsman]: "nl - HDI Pensionsman",
  [StarnormInsuranceCompanyId.NrvRechtsschutz]: "NRV Rechtsschutz",
  [StarnormInsuranceCompanyId.NuernbergerSach]: "NÜRNBERGER Sach",
  [StarnormInsuranceCompanyId.NuernbergerLv]: "NÜRNBERGER LV",
  [StarnormInsuranceCompanyId.NuernbergerKv]: "NÜRNBERGER KV",
  [StarnormInsuranceCompanyId.NvVvag]: "NV VVaG",
  [StarnormInsuranceCompanyId.Ostangler]: "Ostangler",
  [StarnormInsuranceCompanyId.Prokundo]: "Prokundo",
  [StarnormInsuranceCompanyId.ProvinzialMuenster]: "Provinzial (Münster)",
  [StarnormInsuranceCompanyId.RV]: "R+V",
  [StarnormInsuranceCompanyId.RVLvAG]: "R+V LV a.G.",
  [StarnormInsuranceCompanyId.RVKvAg]: "R+V KV AG",
  [StarnormInsuranceCompanyId.RechtsschutzUnion]: "Rechtsschutz Union",
  [StarnormInsuranceCompanyId.Rhion]: "Rhion",
  [StarnormInsuranceCompanyId.RolandRs]: "Roland RS",
  [StarnormInsuranceCompanyId.Sichergruen]: "SicherGRÜN",
  [StarnormInsuranceCompanyId.SignalIdunaLeben]: "Signal Iduna Leben",
  [StarnormInsuranceCompanyId.SignalIduna]: "SIGNAL IDUNA",
  [StarnormInsuranceCompanyId.SignalKv]: "Signal KV",
  [StarnormInsuranceCompanyId.Skandia]: "Skandia",
  [StarnormInsuranceCompanyId.Skendata]: "Skendata",
  [StarnormInsuranceCompanyId.SlpAg]: "SLP AG",
  [StarnormInsuranceCompanyId.SparkasseDirekt]: "Sparkasse Direkt",
  [StarnormInsuranceCompanyId.StandardLife]: "Standard Life",
  [StarnormInsuranceCompanyId.StuttgarterSach]: "Stuttgarter Sach",
  [StarnormInsuranceCompanyId.StuttgarterLeben]: "Stuttgarter Leben",
  [StarnormInsuranceCompanyId.StuttgarterKv]: "Stuttgarter KV",
  [StarnormInsuranceCompanyId.SueddeutscheKv]: "Süddeutsche KV",
  [StarnormInsuranceCompanyId.SwissLifeLv]: "Swiss Life LV",
  [StarnormInsuranceCompanyId.SwissLifeAt]: "Swiss Life AT",
  [StarnormInsuranceCompanyId.UelzenerKomposit]: "Uelzener Komposit",
  [StarnormInsuranceCompanyId.UkvInaktiv]: "UKV inaktiv",
  [StarnormInsuranceCompanyId.UniversaKompositAg]: "uniVersa Komposit AG",
  [StarnormInsuranceCompanyId.UniversaLvAG]: "uniVersa LV a.G.",
  [StarnormInsuranceCompanyId.UniversaKv]: "uniVersa KV",
  [StarnormInsuranceCompanyId.VkbSach]: "VKB Sach",
  [StarnormInsuranceCompanyId.VertiLv]: "Verti LV",
  [StarnormInsuranceCompanyId.VertiSach]: "Verti Sach",
  [StarnormInsuranceCompanyId.Vhv]: "VHV",
  [StarnormInsuranceCompanyId.ViennaLife]: "Vienna-Life",
  [StarnormInsuranceCompanyId.VolkswohlBundSach]: "Volkswohl Bund Sach",
  [StarnormInsuranceCompanyId.VolkswohlBundLeben]: "Volkswohl Bund Leben",
  [StarnormInsuranceCompanyId.Waldenburger]: "Waldenburger",
  [StarnormInsuranceCompanyId.Wueba]: "Wüba",
  [StarnormInsuranceCompanyId.WuerttembergischeAg]: "Württembergische AG",
  [StarnormInsuranceCompanyId.WuerttembergischeLv]: "Württembergische LV",
  [StarnormInsuranceCompanyId.WuerttembergischeKv]: "Württembergische KV",
  [StarnormInsuranceCompanyId.WwkKompositAg]: "WWK Komposit AG",
  [StarnormInsuranceCompanyId.WwkLv]: "WWK LV",
  [StarnormInsuranceCompanyId.Zurich]: "Zurich",
  [StarnormInsuranceCompanyId.ZurichLv]: "Zurich LV",
  [StarnormInsuranceCompanyId.ZurichLifeIrland]: "Zurich Life (Irland)",
  [StarnormInsuranceCompanyId.Zurichkfztool]: "ZurichKFZTool",
} as const;

export function getStarnormInsuranceCompanyLabel(id: StarnormInsuranceCompanyId): string {
  return STARNORM_INSURANCE_COMPANY_LABELS[id] ?? id;
}

export type StarnormInsuranceCompanyCategory = "composite" | "life" | "health";

export const STARNORM_INSURANCE_COMPANY_CATEGORIES = {
  [StarnormInsuranceCompanyId.AdamRiese]: "composite",
  [StarnormInsuranceCompanyId.Adcuri]: "composite",
  [StarnormInsuranceCompanyId.Aia]: "composite",
  [StarnormInsuranceCompanyId.Aig]: "composite",
  [StarnormInsuranceCompanyId.AllianzSach]: "composite",
  [StarnormInsuranceCompanyId.AllianzLeben]: "life",
  [StarnormInsuranceCompanyId.AllianzKv]: "health",
  [StarnormInsuranceCompanyId.Allianzagrar]: "composite",
  [StarnormInsuranceCompanyId.AlteLeipzigerLv]: "life",
  [StarnormInsuranceCompanyId.Alteleipziger]: "composite",
  [StarnormInsuranceCompanyId.AlteOldenburger]: "health",
  [StarnormInsuranceCompanyId.Alteos]: "composite",
  [StarnormInsuranceCompanyId.AmmerlaenderVvag]: "composite",
  [StarnormInsuranceCompanyId.Andsafe]: "composite",
  [StarnormInsuranceCompanyId.AngloUnderwriting]: "composite",
  [StarnormInsuranceCompanyId.AprilDeutschland]: "health",
  [StarnormInsuranceCompanyId.AragAllgVersAg]: "composite",
  [StarnormInsuranceCompanyId.AragKvAg]: "health",
  [StarnormInsuranceCompanyId.AxaDbv]: "composite",
  [StarnormInsuranceCompanyId.AxaDbvLeben]: "life",
  [StarnormInsuranceCompanyId.AxaDbvKv]: "health",
  [StarnormInsuranceCompanyId.BadenBadener]: "composite",
  [StarnormInsuranceCompanyId.BaloiseSach]: "composite",
  [StarnormInsuranceCompanyId.BaloiseLv]: "life",
  [StarnormInsuranceCompanyId.BaloiseLvAlt]: "life",
  [StarnormInsuranceCompanyId.BarmeniaSach]: "composite",
  [StarnormInsuranceCompanyId.BarmeniaLv]: "life",
  [StarnormInsuranceCompanyId.BarmeniaKv]: "health",
  [StarnormInsuranceCompanyId.BbkkUnionKv]: "health",
  [StarnormInsuranceCompanyId.Bgv]: "composite",
  [StarnormInsuranceCompanyId.Bgvkfztool]: "composite",
  [StarnormInsuranceCompanyId.Blaudirektver]: "composite",
  [StarnormInsuranceCompanyId.Bsg]: "composite",
  [StarnormInsuranceCompanyId.CanadaLife]: "life",
  [StarnormInsuranceCompanyId.CareConceptAg]: "health",
  [StarnormInsuranceCompanyId.CentralKv]: "health",
  [StarnormInsuranceCompanyId.CfiFairpay]: "life",
  [StarnormInsuranceCompanyId.Compactteam]: "composite",
  [StarnormInsuranceCompanyId.ConceptifAg]: "composite",
  [StarnormInsuranceCompanyId.Concordia]: "composite",
  [StarnormInsuranceCompanyId.ConcordiaLvAg]: "life",
  [StarnormInsuranceCompanyId.ConcordiaKvAg]: "health",
  [StarnormInsuranceCompanyId.Concordiakfztool]: "composite",
  [StarnormInsuranceCompanyId.CondorLvAg]: "life",
  [StarnormInsuranceCompanyId.Continentale]: "composite",
  [StarnormInsuranceCompanyId.ContinentaleLv]: "life",
  [StarnormInsuranceCompanyId.ContinentaleKv]: "health",
  [StarnormInsuranceCompanyId.Covomo]: "composite",
  [StarnormInsuranceCompanyId.DaDirekt]: "composite",
  [StarnormInsuranceCompanyId.DbVitaPremium]: "life",
  [StarnormInsuranceCompanyId.DbVitaPremiumSel]: "life",
  [StarnormInsuranceCompanyId.Dela]: "life",
  [StarnormInsuranceCompanyId.Deurag]: "composite",
  [StarnormInsuranceCompanyId.DfvKv]: "health",
  [StarnormInsuranceCompanyId.DialogSach]: "composite",
  [StarnormInsuranceCompanyId.DialogLeben]: "life",
  [StarnormInsuranceCompanyId.DieBayerischeSach]: "composite",
  [StarnormInsuranceCompanyId.DieBayerischeLv]: "life",
  [StarnormInsuranceCompanyId.DieBayerischeKv]: "health",
  [StarnormInsuranceCompanyId.DieHaftpflichtkasse]: "composite",
  [StarnormInsuranceCompanyId.DkvDeutscheKvAg]: "health",
  [StarnormInsuranceCompanyId.DmbRsAg]: "composite",
  [StarnormInsuranceCompanyId.DocuraVvag]: "composite",
  [StarnormInsuranceCompanyId.Domcura]: "composite",
  [StarnormInsuranceCompanyId.DomcuraKv]: "health",
  [StarnormInsuranceCompanyId.ErgoAg]: "composite",
  [StarnormInsuranceCompanyId.ErgoLvAg]: "life",
  [StarnormInsuranceCompanyId.ErgoDirekt]: "life",
  [StarnormInsuranceCompanyId.ErgoLifeSaVLux]: "life",
  [StarnormInsuranceCompanyId.Europa]: "composite",
  [StarnormInsuranceCompanyId.EuropaKv]: "health",
  [StarnormInsuranceCompanyId.EuropaLvAg]: "life",
  [StarnormInsuranceCompanyId.FidelisUnderwriting]: "composite",
  [StarnormInsuranceCompanyId.Forbrokergmbh]: "composite",
  [StarnormInsuranceCompanyId.GerlingGA]: "composite",
  [StarnormInsuranceCompanyId.GermanbrokerNetAg]: "composite",
  [StarnormInsuranceCompanyId.GothaerSach]: "composite",
  [StarnormInsuranceCompanyId.GothaerLeben]: "life",
  [StarnormInsuranceCompanyId.GothaerKv]: "health",
  [StarnormInsuranceCompanyId.Grundeigentuemer]: "composite",
  [StarnormInsuranceCompanyId.GvoVvag]: "composite",
  [StarnormInsuranceCompanyId.Hallesche]: "health",
  [StarnormInsuranceCompanyId.HannoverscheLeben]: "life",
  [StarnormInsuranceCompanyId.HansemerkurKomposit]: "composite",
  [StarnormInsuranceCompanyId.HansemerkurLv]: "life",
  [StarnormInsuranceCompanyId.HansemerkurKv]: "health",
  [StarnormInsuranceCompanyId.HdiPrivatGewerbe]: "composite",
  [StarnormInsuranceCompanyId.Hdi]: "life",
  [StarnormInsuranceCompanyId.HdiGewerbeInaktiv]: "composite",
  [StarnormInsuranceCompanyId.HdiGlobalSe]: "composite",
  [StarnormInsuranceCompanyId.Hek]: "health",
  [StarnormInsuranceCompanyId.HelvetiaKompositAg]: "composite",
  [StarnormInsuranceCompanyId.HelvetiaLvAg]: "life",
  [StarnormInsuranceCompanyId.Hiscox]: "composite",
  [StarnormInsuranceCompanyId.HuebenerAg]: "composite",
  [StarnormInsuranceCompanyId.IdealSach]: "composite",
  [StarnormInsuranceCompanyId.IdealLeben]: "life",
  [StarnormInsuranceCompanyId.InoraLife]: "life",
  [StarnormInsuranceCompanyId.Intasure]: "composite",
  [StarnormInsuranceCompanyId.InterSach]: "composite",
  [StarnormInsuranceCompanyId.InterLv]: "life",
  [StarnormInsuranceCompanyId.InterKv]: "health",
  [StarnormInsuranceCompanyId.InterlloydAg]: "composite",
  [StarnormInsuranceCompanyId.Interrisk]: "composite",
  [StarnormInsuranceCompanyId.InterriskLeben]: "life",
  [StarnormInsuranceCompanyId.Itzehoer]: "composite",
  [StarnormInsuranceCompanyId.Janitos]: "composite",
  [StarnormInsuranceCompanyId.JanitosKv]: "health",
  [StarnormInsuranceCompanyId.KM]: "composite",
  [StarnormInsuranceCompanyId.Kravag]: "composite",
  [StarnormInsuranceCompanyId.KsAuxilia]: "composite",
  [StarnormInsuranceCompanyId.Landeskrankenhilfe]: "health",
  [StarnormInsuranceCompanyId.LibertyEurope]: "life",
  [StarnormInsuranceCompanyId.Lta]: "composite",
  [StarnormInsuranceCompanyId.Lv1871Sach]: "composite",
  [StarnormInsuranceCompanyId.Lv1871]: "life",
  [StarnormInsuranceCompanyId.MannheimerKomposit]: "composite",
  [StarnormInsuranceCompanyId.ManufakturAugsburg]: "composite",
  [StarnormInsuranceCompanyId.MarkelInternational]: "composite",
  [StarnormInsuranceCompanyId.MuenchenerVereinLv]: "life",
  [StarnormInsuranceCompanyId.MuenchenerVereinKv]: "health",
  [StarnormInsuranceCompanyId.MylifeLvAg]: "life",
  [StarnormInsuranceCompanyId.Neodigital]: "composite",
  [StarnormInsuranceCompanyId.NeueLeben]: "life",
  [StarnormInsuranceCompanyId.NlHdiPensionsman]: "life",
  [StarnormInsuranceCompanyId.NrvRechtsschutz]: "composite",
  [StarnormInsuranceCompanyId.NuernbergerSach]: "composite",
  [StarnormInsuranceCompanyId.NuernbergerLv]: "life",
  [StarnormInsuranceCompanyId.NuernbergerKv]: "health",
  [StarnormInsuranceCompanyId.NvVvag]: "composite",
  [StarnormInsuranceCompanyId.Ostangler]: "composite",
  [StarnormInsuranceCompanyId.Prokundo]: "composite",
  [StarnormInsuranceCompanyId.ProvinzialMuenster]: "composite",
  [StarnormInsuranceCompanyId.RV]: "composite",
  [StarnormInsuranceCompanyId.RVLvAG]: "life",
  [StarnormInsuranceCompanyId.RVKvAg]: "health",
  [StarnormInsuranceCompanyId.RechtsschutzUnion]: "composite",
  [StarnormInsuranceCompanyId.Rhion]: "composite",
  [StarnormInsuranceCompanyId.RolandRs]: "composite",
  [StarnormInsuranceCompanyId.Sichergruen]: "composite",
  [StarnormInsuranceCompanyId.SignalIdunaLeben]: "life",
  [StarnormInsuranceCompanyId.SignalIduna]: "composite",
  [StarnormInsuranceCompanyId.SignalKv]: "health",
  [StarnormInsuranceCompanyId.Skandia]: "life",
  [StarnormInsuranceCompanyId.Skendata]: "composite",
  [StarnormInsuranceCompanyId.SlpAg]: "composite",
  [StarnormInsuranceCompanyId.SparkasseDirekt]: "composite",
  [StarnormInsuranceCompanyId.StandardLife]: "life",
  [StarnormInsuranceCompanyId.StuttgarterSach]: "composite",
  [StarnormInsuranceCompanyId.StuttgarterLeben]: "life",
  [StarnormInsuranceCompanyId.StuttgarterKv]: "health",
  [StarnormInsuranceCompanyId.SueddeutscheKv]: "health",
  [StarnormInsuranceCompanyId.SwissLifeLv]: "life",
  [StarnormInsuranceCompanyId.SwissLifeAt]: "life",
  [StarnormInsuranceCompanyId.UelzenerKomposit]: "composite",
  [StarnormInsuranceCompanyId.UkvInaktiv]: "health",
  [StarnormInsuranceCompanyId.UniversaKompositAg]: "composite",
  [StarnormInsuranceCompanyId.UniversaLvAG]: "life",
  [StarnormInsuranceCompanyId.UniversaKv]: "health",
  [StarnormInsuranceCompanyId.VkbSach]: "composite",
  [StarnormInsuranceCompanyId.VertiLv]: "life",
  [StarnormInsuranceCompanyId.VertiSach]: "composite",
  [StarnormInsuranceCompanyId.Vhv]: "composite",
  [StarnormInsuranceCompanyId.ViennaLife]: "life",
  [StarnormInsuranceCompanyId.VolkswohlBundSach]: "composite",
  [StarnormInsuranceCompanyId.VolkswohlBundLeben]: "life",
  [StarnormInsuranceCompanyId.Waldenburger]: "composite",
  [StarnormInsuranceCompanyId.Wueba]: "composite",
  [StarnormInsuranceCompanyId.WuerttembergischeAg]: "composite",
  [StarnormInsuranceCompanyId.WuerttembergischeLv]: "life",
  [StarnormInsuranceCompanyId.WuerttembergischeKv]: "health",
  [StarnormInsuranceCompanyId.WwkKompositAg]: "composite",
  [StarnormInsuranceCompanyId.WwkLv]: "life",
  [StarnormInsuranceCompanyId.Zurich]: "composite",
  [StarnormInsuranceCompanyId.ZurichLv]: "life",
  [StarnormInsuranceCompanyId.ZurichLifeIrland]: "life",
  [StarnormInsuranceCompanyId.Zurichkfztool]: "composite",
} as const;

type ExtractCompaniesForCategory<C extends StarnormInsuranceCompanyCategory> = {
  [K in StarnormInsuranceCompanyId]: (typeof STARNORM_INSURANCE_COMPANY_CATEGORIES)[K] extends C ? K : never;
}[StarnormInsuranceCompanyId];

export type CompositeInsuranceCompanyId = ExtractCompaniesForCategory<"composite">;
export type LifeInsuranceCompanyId = ExtractCompaniesForCategory<"life">;
export type HealthInsuranceCompanyId = ExtractCompaniesForCategory<"health">;
